export default {
  name: 'ProgressHUD',
  props: {
    display: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayProgress: this.display
    }
  },
  methods: {
    show: function() {
      this.displayProgress = true;
    },
    hide: function() {
      this.displayProgress = false;
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/ProgressHUD/ProgressHUD.component.js